import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=64963c1e&scoped=true"
import script from "./EditTag.vue?vue&type=script&lang=js"
export * from "./EditTag.vue?vue&type=script&lang=js"
import style0 from "./EditTag.vue?vue&type=style&index=0&id=64963c1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64963c1e",
  null
  
)

export default component.exports